/* */ 
"use strict";
Object.defineProperty(exports, "__esModule", {value: true});
exports.showNotificationListCompleted = exports.showFuturePaymentDetailsCompleted = exports.showAccountTransactionDetailsCompleted = exports.showEnrollAccountsCompleted = exports.showTransferDragAndDropFormCompleted = exports.showTransferFormCompleted = exports.showSnapCashCompleted = exports.showPaymentAgreementListCompleted = exports.showMyAdvisorCompleted = exports.showMessageListCompleted = exports.showLoginFormCompleted = exports.showLoansTransactionListCompleted = exports.showLoansTermsCompleted = exports.showLoansListCompleted = exports.showLoanTransactionListCompleted = exports.showLoanTermsCompleted = exports.showLoanListCompleted = exports.showLanguageSelectorCompleted = exports.showKidPaymentFormCompleted = exports.showFindUsCompleted = exports.showDialogCompleted = exports.showEFakturaPaymentFormCompleted = exports.showEFakturaListCompleted = exports.showEFakturaDragAndDropFormCompleted = exports.showEditFavoriteAccountsCompleted = exports.showCurrencyConverterCompleted = exports.showCreditCardTransactionListCompleted = exports.showCreditCardListCompleted = exports.showBlockCardCompleted = exports.showApprovePaymentsCompleted = exports.showAccountTransactionListCompleted = exports.showAccountTermsCompleted = exports.showAccountListCompleted = exports.showAgreementSelectorCompleted = exports.getFavouriteAccountsCompleted = exports.changeLanguageCompleted = exports.setAgreementCompleted = exports.doLogoutCompleted = exports.futurePaymentChanged = exports.accountTransactionDetailsUpdated = exports.accountNameChanged = exports.enrollAccountsChanged = exports.overviewChanged = exports.transferSucceeded = exports.snapCashPaymentSucceeded = exports.kidPaymentSucceeded = exports.efakturaDeletionSucceeded = exports.efakturaPaymentSucceeded = exports.favoriteAccountsSelectionChanged = exports.agreementChangeSucceeded = exports.getFavouriteAccountsSucceeded = exports.languageChangeSucceeded = exports.loginSucceeded = void 0;
var _events = require('./events');
var loginSucceeded = function loginSucceeded() {
  for (var _len = arguments.length,
      args = new Array(_len),
      _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.LOGIN_SUCCEED].concat(args));
};
exports.loginSucceeded = loginSucceeded;
var languageChangeSucceeded = function languageChangeSucceeded() {
  for (var _len2 = arguments.length,
      args = new Array(_len2),
      _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.LANGUAGE_CHANGE_SUCCEEDED].concat(args));
};
exports.languageChangeSucceeded = languageChangeSucceeded;
var getFavouriteAccountsSucceeded = function getFavouriteAccountsSucceeded() {
  for (var _len3 = arguments.length,
      args = new Array(_len3),
      _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.GET_FAVOURITE_ACCOUNTS_SUCCEEDED].concat(args));
};
exports.getFavouriteAccountsSucceeded = getFavouriteAccountsSucceeded;
var agreementChangeSucceeded = function agreementChangeSucceeded() {
  for (var _len4 = arguments.length,
      args = new Array(_len4),
      _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.AGREEMENT_CHANGE_SUCCEEDED].concat(args));
};
exports.agreementChangeSucceeded = agreementChangeSucceeded;
var favoriteAccountsSelectionChanged = function favoriteAccountsSelectionChanged() {
  for (var _len5 = arguments.length,
      args = new Array(_len5),
      _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.FAVORITE_ACCOUNTS_SELECTION_CHANGED].concat(args));
};
exports.favoriteAccountsSelectionChanged = favoriteAccountsSelectionChanged;
var efakturaPaymentSucceeded = function efakturaPaymentSucceeded() {
  for (var _len6 = arguments.length,
      args = new Array(_len6),
      _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.EFAKTURA_PAYMENT_SUCCEEDED].concat(args));
};
exports.efakturaPaymentSucceeded = efakturaPaymentSucceeded;
var efakturaDeletionSucceeded = function efakturaDeletionSucceeded() {
  for (var _len7 = arguments.length,
      args = new Array(_len7),
      _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.EFAKTURA_DELETION_SUCCEEDED].concat(args));
};
exports.efakturaDeletionSucceeded = efakturaDeletionSucceeded;
var kidPaymentSucceeded = function kidPaymentSucceeded() {
  for (var _len8 = arguments.length,
      args = new Array(_len8),
      _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.KID_PAYMENT_SUCCEEDED].concat(args));
};
exports.kidPaymentSucceeded = kidPaymentSucceeded;
var snapCashPaymentSucceeded = function snapCashPaymentSucceeded() {
  for (var _len9 = arguments.length,
      args = new Array(_len9),
      _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SNAPCASH_PAYMENT_SUCCEEDED].concat(args));
};
exports.snapCashPaymentSucceeded = snapCashPaymentSucceeded;
var transferSucceeded = function transferSucceeded() {
  for (var _len10 = arguments.length,
      args = new Array(_len10),
      _key10 = 0; _key10 < _len10; _key10++) {
    args[_key10] = arguments[_key10];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.TRANSFER_SUCCEEDED].concat(args));
};
exports.transferSucceeded = transferSucceeded;
var overviewChanged = function overviewChanged() {
  for (var _len11 = arguments.length,
      args = new Array(_len11),
      _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.OVERVIEW_CHANGED].concat(args));
};
exports.overviewChanged = overviewChanged;
var enrollAccountsChanged = function enrollAccountsChanged() {
  for (var _len12 = arguments.length,
      args = new Array(_len12),
      _key12 = 0; _key12 < _len12; _key12++) {
    args[_key12] = arguments[_key12];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.ENROLL_ACCOUNTS_CHANGED].concat(args));
};
exports.enrollAccountsChanged = enrollAccountsChanged;
var accountNameChanged = function accountNameChanged() {
  for (var _len13 = arguments.length,
      args = new Array(_len13),
      _key13 = 0; _key13 < _len13; _key13++) {
    args[_key13] = arguments[_key13];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.ACCOUNT_NAME_CHANGED].concat(args));
};
exports.accountNameChanged = accountNameChanged;
var accountTransactionDetailsUpdated = function accountTransactionDetailsUpdated() {
  for (var _len14 = arguments.length,
      args = new Array(_len14),
      _key14 = 0; _key14 < _len14; _key14++) {
    args[_key14] = arguments[_key14];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.ACCOUNT_TRANSACTION_DETAILS_UPDATED].concat(args));
};
exports.accountTransactionDetailsUpdated = accountTransactionDetailsUpdated;
var futurePaymentChanged = function futurePaymentChanged() {
  for (var _len15 = arguments.length,
      args = new Array(_len15),
      _key15 = 0; _key15 < _len15; _key15++) {
    args[_key15] = arguments[_key15];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.FUTURE_PAYMENT_CHANGED].concat(args));
};
exports.futurePaymentChanged = futurePaymentChanged;
var doLogoutCompleted = function doLogoutCompleted() {
  for (var _len16 = arguments.length,
      args = new Array(_len16),
      _key16 = 0; _key16 < _len16; _key16++) {
    args[_key16] = arguments[_key16];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.LOGOUT_COMPLETED].concat(args));
};
exports.doLogoutCompleted = doLogoutCompleted;
var setAgreementCompleted = function setAgreementCompleted() {
  for (var _len17 = arguments.length,
      args = new Array(_len17),
      _key17 = 0; _key17 < _len17; _key17++) {
    args[_key17] = arguments[_key17];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.AGREMENT_SWITCHED].concat(args));
};
exports.setAgreementCompleted = setAgreementCompleted;
var changeLanguageCompleted = function changeLanguageCompleted() {
  for (var _len18 = arguments.length,
      args = new Array(_len18),
      _key18 = 0; _key18 < _len18; _key18++) {
    args[_key18] = arguments[_key18];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.CHANGE_LANGUAGE_COMPLETED].concat(args));
};
exports.changeLanguageCompleted = changeLanguageCompleted;
var getFavouriteAccountsCompleted = function getFavouriteAccountsCompleted() {
  for (var _len19 = arguments.length,
      args = new Array(_len19),
      _key19 = 0; _key19 < _len19; _key19++) {
    args[_key19] = arguments[_key19];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.GET_FAVOURITE_ACCOUNTS_COMPLETED].concat(args));
};
exports.getFavouriteAccountsCompleted = getFavouriteAccountsCompleted;
var showAgreementSelectorCompleted = function showAgreementSelectorCompleted() {
  for (var _len20 = arguments.length,
      args = new Array(_len20),
      _key20 = 0; _key20 < _len20; _key20++) {
    args[_key20] = arguments[_key20];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_AGREEMENT_SELECTOR_COMPLETED].concat(args));
};
exports.showAgreementSelectorCompleted = showAgreementSelectorCompleted;
var showAccountListCompleted = function showAccountListCompleted() {
  for (var _len21 = arguments.length,
      args = new Array(_len21),
      _key21 = 0; _key21 < _len21; _key21++) {
    args[_key21] = arguments[_key21];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_ACCOUNT_LIST_COMPLETED].concat(args));
};
exports.showAccountListCompleted = showAccountListCompleted;
var showAccountTermsCompleted = function showAccountTermsCompleted() {
  for (var _len22 = arguments.length,
      args = new Array(_len22),
      _key22 = 0; _key22 < _len22; _key22++) {
    args[_key22] = arguments[_key22];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_ACCOUNT_TERMS_COMPLETED].concat(args));
};
exports.showAccountTermsCompleted = showAccountTermsCompleted;
var showAccountTransactionListCompleted = function showAccountTransactionListCompleted() {
  for (var _len23 = arguments.length,
      args = new Array(_len23),
      _key23 = 0; _key23 < _len23; _key23++) {
    args[_key23] = arguments[_key23];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_ACCOUNT_TRANSACTION_LIST_COMPLETED].concat(args));
};
exports.showAccountTransactionListCompleted = showAccountTransactionListCompleted;
var showApprovePaymentsCompleted = function showApprovePaymentsCompleted() {
  for (var _len24 = arguments.length,
      args = new Array(_len24),
      _key24 = 0; _key24 < _len24; _key24++) {
    args[_key24] = arguments[_key24];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_APPROVE_PAYMENTS_COMPLETED].concat(args));
};
exports.showApprovePaymentsCompleted = showApprovePaymentsCompleted;
var showBlockCardCompleted = function showBlockCardCompleted() {
  for (var _len25 = arguments.length,
      args = new Array(_len25),
      _key25 = 0; _key25 < _len25; _key25++) {
    args[_key25] = arguments[_key25];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_BLOCK_CARD_COMPLETED].concat(args));
};
exports.showBlockCardCompleted = showBlockCardCompleted;
var showCreditCardListCompleted = function showCreditCardListCompleted() {
  for (var _len26 = arguments.length,
      args = new Array(_len26),
      _key26 = 0; _key26 < _len26; _key26++) {
    args[_key26] = arguments[_key26];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_CREDIT_CARD_LIST_COMPLETED].concat(args));
};
exports.showCreditCardListCompleted = showCreditCardListCompleted;
var showCreditCardTransactionListCompleted = function showCreditCardTransactionListCompleted() {
  for (var _len27 = arguments.length,
      args = new Array(_len27),
      _key27 = 0; _key27 < _len27; _key27++) {
    args[_key27] = arguments[_key27];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_CREDIT_CARD_TRANSACTION_LIST_COMPLETED].concat(args));
};
exports.showCreditCardTransactionListCompleted = showCreditCardTransactionListCompleted;
var showCurrencyConverterCompleted = function showCurrencyConverterCompleted() {
  for (var _len28 = arguments.length,
      args = new Array(_len28),
      _key28 = 0; _key28 < _len28; _key28++) {
    args[_key28] = arguments[_key28];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_CURRENCY_CONVERTER_COMPLETED].concat(args));
};
exports.showCurrencyConverterCompleted = showCurrencyConverterCompleted;
var showEditFavoriteAccountsCompleted = function showEditFavoriteAccountsCompleted() {
  for (var _len29 = arguments.length,
      args = new Array(_len29),
      _key29 = 0; _key29 < _len29; _key29++) {
    args[_key29] = arguments[_key29];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_EDIT_FAVORITE_ACCOUNTS_COMPLETED].concat(args));
};
exports.showEditFavoriteAccountsCompleted = showEditFavoriteAccountsCompleted;
var showEFakturaDragAndDropFormCompleted = function showEFakturaDragAndDropFormCompleted() {
  for (var _len30 = arguments.length,
      args = new Array(_len30),
      _key30 = 0; _key30 < _len30; _key30++) {
    args[_key30] = arguments[_key30];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_E_FAKTURA_DRAG_AND_DROP_FORM_COMPLETED].concat(args));
};
exports.showEFakturaDragAndDropFormCompleted = showEFakturaDragAndDropFormCompleted;
var showEFakturaListCompleted = function showEFakturaListCompleted() {
  for (var _len31 = arguments.length,
      args = new Array(_len31),
      _key31 = 0; _key31 < _len31; _key31++) {
    args[_key31] = arguments[_key31];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_E_FAKTURA_LIST_COMPLETED].concat(args));
};
exports.showEFakturaListCompleted = showEFakturaListCompleted;
var showEFakturaPaymentFormCompleted = function showEFakturaPaymentFormCompleted() {
  for (var _len32 = arguments.length,
      args = new Array(_len32),
      _key32 = 0; _key32 < _len32; _key32++) {
    args[_key32] = arguments[_key32];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_E_FAKTURA_PAYMENT_FORM_COMPLETED].concat(args));
};
exports.showEFakturaPaymentFormCompleted = showEFakturaPaymentFormCompleted;
var showDialogCompleted = function showDialogCompleted() {
  for (var _len33 = arguments.length,
      args = new Array(_len33),
      _key33 = 0; _key33 < _len33; _key33++) {
    args[_key33] = arguments[_key33];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_DIALOG_COMPLETED].concat(args));
};
exports.showDialogCompleted = showDialogCompleted;
var showFindUsCompleted = function showFindUsCompleted() {
  for (var _len34 = arguments.length,
      args = new Array(_len34),
      _key34 = 0; _key34 < _len34; _key34++) {
    args[_key34] = arguments[_key34];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_FIND_US_COMPLETED].concat(args));
};
exports.showFindUsCompleted = showFindUsCompleted;
var showKidPaymentFormCompleted = function showKidPaymentFormCompleted() {
  for (var _len35 = arguments.length,
      args = new Array(_len35),
      _key35 = 0; _key35 < _len35; _key35++) {
    args[_key35] = arguments[_key35];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_KID_PAYMENT_FORM_COMPLETED].concat(args));
};
exports.showKidPaymentFormCompleted = showKidPaymentFormCompleted;
var showLanguageSelectorCompleted = function showLanguageSelectorCompleted() {
  for (var _len36 = arguments.length,
      args = new Array(_len36),
      _key36 = 0; _key36 < _len36; _key36++) {
    args[_key36] = arguments[_key36];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_LANGUAGE_SELECTOR_COMPLETED].concat(args));
};
exports.showLanguageSelectorCompleted = showLanguageSelectorCompleted;
var showLoanListCompleted = function showLoanListCompleted() {
  for (var _len37 = arguments.length,
      args = new Array(_len37),
      _key37 = 0; _key37 < _len37; _key37++) {
    args[_key37] = arguments[_key37];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_LOANS_LIST_COMPLETED].concat(args));
};
exports.showLoanListCompleted = showLoanListCompleted;
var showLoanTermsCompleted = function showLoanTermsCompleted() {
  for (var _len38 = arguments.length,
      args = new Array(_len38),
      _key38 = 0; _key38 < _len38; _key38++) {
    args[_key38] = arguments[_key38];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_LOANS_TERMS_COMPLETED].concat(args));
};
exports.showLoanTermsCompleted = showLoanTermsCompleted;
var showLoanTransactionListCompleted = function showLoanTransactionListCompleted() {
  for (var _len39 = arguments.length,
      args = new Array(_len39),
      _key39 = 0; _key39 < _len39; _key39++) {
    args[_key39] = arguments[_key39];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_LOANS_TRANSACTION_LIST_COMPLETED].concat(args));
};
exports.showLoanTransactionListCompleted = showLoanTransactionListCompleted;
var showLoansListCompleted = function showLoansListCompleted() {
  for (var _len40 = arguments.length,
      args = new Array(_len40),
      _key40 = 0; _key40 < _len40; _key40++) {
    args[_key40] = arguments[_key40];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_LOANS_LIST_COMPLETED].concat(args));
};
exports.showLoansListCompleted = showLoansListCompleted;
var showLoansTermsCompleted = function showLoansTermsCompleted() {
  for (var _len41 = arguments.length,
      args = new Array(_len41),
      _key41 = 0; _key41 < _len41; _key41++) {
    args[_key41] = arguments[_key41];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_LOANS_TERMS_COMPLETED].concat(args));
};
exports.showLoansTermsCompleted = showLoansTermsCompleted;
var showLoansTransactionListCompleted = function showLoansTransactionListCompleted() {
  for (var _len42 = arguments.length,
      args = new Array(_len42),
      _key42 = 0; _key42 < _len42; _key42++) {
    args[_key42] = arguments[_key42];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_LOANS_TRANSACTION_LIST_COMPLETED].concat(args));
};
exports.showLoansTransactionListCompleted = showLoansTransactionListCompleted;
var showLoginFormCompleted = function showLoginFormCompleted() {
  for (var _len43 = arguments.length,
      args = new Array(_len43),
      _key43 = 0; _key43 < _len43; _key43++) {
    args[_key43] = arguments[_key43];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_LOGIN_FORM_COMPLETED].concat(args));
};
exports.showLoginFormCompleted = showLoginFormCompleted;
var showMessageListCompleted = function showMessageListCompleted() {
  for (var _len44 = arguments.length,
      args = new Array(_len44),
      _key44 = 0; _key44 < _len44; _key44++) {
    args[_key44] = arguments[_key44];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_MESSAGE_LIST_COMPLETED].concat(args));
};
exports.showMessageListCompleted = showMessageListCompleted;
var showMyAdvisorCompleted = function showMyAdvisorCompleted() {
  for (var _len45 = arguments.length,
      args = new Array(_len45),
      _key45 = 0; _key45 < _len45; _key45++) {
    args[_key45] = arguments[_key45];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_MY_ADVISOR_COMPLETED].concat(args));
};
exports.showMyAdvisorCompleted = showMyAdvisorCompleted;
var showPaymentAgreementListCompleted = function showPaymentAgreementListCompleted() {
  for (var _len46 = arguments.length,
      args = new Array(_len46),
      _key46 = 0; _key46 < _len46; _key46++) {
    args[_key46] = arguments[_key46];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_PAYMENT_AGREEMENT_LIST_COMPLETED].concat(args));
};
exports.showPaymentAgreementListCompleted = showPaymentAgreementListCompleted;
var showSnapCashCompleted = function showSnapCashCompleted() {
  for (var _len47 = arguments.length,
      args = new Array(_len47),
      _key47 = 0; _key47 < _len47; _key47++) {
    args[_key47] = arguments[_key47];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_SNAP_CASH_COMPLETED].concat(args));
};
exports.showSnapCashCompleted = showSnapCashCompleted;
var showTransferFormCompleted = function showTransferFormCompleted() {
  for (var _len48 = arguments.length,
      args = new Array(_len48),
      _key48 = 0; _key48 < _len48; _key48++) {
    args[_key48] = arguments[_key48];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_TRANSFER_FORM_COMPLETED].concat(args));
};
exports.showTransferFormCompleted = showTransferFormCompleted;
var showTransferDragAndDropFormCompleted = function showTransferDragAndDropFormCompleted() {
  for (var _len49 = arguments.length,
      args = new Array(_len49),
      _key49 = 0; _key49 < _len49; _key49++) {
    args[_key49] = arguments[_key49];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_TRANSFER_DRAG_AND_DROP_FORM_COMPLETED].concat(args));
};
exports.showTransferDragAndDropFormCompleted = showTransferDragAndDropFormCompleted;
var showEnrollAccountsCompleted = function showEnrollAccountsCompleted() {
  for (var _len50 = arguments.length,
      args = new Array(_len50),
      _key50 = 0; _key50 < _len50; _key50++) {
    args[_key50] = arguments[_key50];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.ENROLL_ACCOUNTS_COMPLETED].concat(args));
};
exports.showEnrollAccountsCompleted = showEnrollAccountsCompleted;
var showAccountTransactionDetailsCompleted = function showAccountTransactionDetailsCompleted() {
  for (var _len51 = arguments.length,
      args = new Array(_len51),
      _key51 = 0; _key51 < _len51; _key51++) {
    args[_key51] = arguments[_key51];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_ACCOUNT_TRANSACTION_DETAILS_COMPLETED].concat(args));
};
exports.showAccountTransactionDetailsCompleted = showAccountTransactionDetailsCompleted;
var showFuturePaymentDetailsCompleted = function showFuturePaymentDetailsCompleted() {
  for (var _len52 = arguments.length,
      args = new Array(_len52),
      _key52 = 0; _key52 < _len52; _key52++) {
    args[_key52] = arguments[_key52];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_FUTURE_PAYMENT_DETAILS_COMPLETED].concat(args));
};
exports.showFuturePaymentDetailsCompleted = showFuturePaymentDetailsCompleted;
var showNotificationListCompleted = function showNotificationListCompleted() {
  for (var _len53 = arguments.length,
      args = new Array(_len53),
      _key53 = 0; _key53 < _len53; _key53++) {
    args[_key53] = arguments[_key53];
  }
  _events.trigger.apply(void 0, [_events.EVENTS.SHOW_NOTIFICATION_LIST_COMPLETED].concat(args));
};
exports.showNotificationListCompleted = showNotificationListCompleted;
